import { WebUserReference } from './web-user';
import { AdminUserReference } from './admin-user';
import { WorkStatus } from './work-status';

export interface UniqueRequest {
    id: string;
    createdAt: Date;
    user: WebUserReference;
    caseNumber: string;
    type: UniqueRequestType;
    subject: string;
    insideNote: string;
    status: WorkStatus;
    statusHistory: WorkStatus[];
    messages: UniqueRequestMessage[];
    unanswered: boolean;
}

export interface UniqueRequestMessage {
    id: string;
    createdAt: Date;
    uniqueRequestId: string;
    messageCaseNumber: string;
    origin: UniqueRequestMessageOrigin;
    content: string;
    attachments: UniqueRequestAttachment[];
    admin?: AdminUserReference;
    read: boolean;
}

export enum UniqueRequestType {
    Document = 'Document',
    DebtFree = 'DebtFree',
    Unique = 'Unique',
}

export enum UniqueRequestMessageOrigin {
    Admin = 'Admin',
    Web = 'Web',
}

export interface UniqueRequestAttachment {
    name: string;
    url: string;
}

export interface UniqueRequestTemplate {
    id: string;
    createdAt: Date;
    updatedAt: Date;
    name: string;
    content: string;
}
